import React, {useRef, useState } from "react";
import MonthCalendar from "./MonthCalendar";
import DayCalendar from "./DayCalendar";
import ListCalendar from "./ListCalendar";
import "./Calendar.css";
import useInfiniteMonths from "./useInfiniteMonths";
import EventCard from "./EventCard";
import CalendarSelector from "./CalendarSelector";
import {getNextMonth, getInitialMonths} from "./dateUtils";

const calendars = [
  {
    label: "Swing",
    id: "7qjrf8hhnfstohtrkq2cs2ursg@group.calendar.google.com",
  },
  {
    label: "Blues",
    id: "5f7910q3e58s1dsnj47hkjhm1s@group.calendar.google.com",
  },
];

function Calendar() {

  //initializing eventcard & calendar container & loading...
  const popupRef = useRef(null);
  const calendarContainerRef =useRef(null);
  const loadMoreRef = useRef(null);

  //State
  const [selectedCalendars, setSelectedCalendars] = useState([calendars[0].id, calendars[1].id]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [months, setMonths] = useState(getInitialMonths);
  const [calendarView, setCalendarView] = useState("month");

  //React hook to generate more months w/ scroll
  useInfiniteMonths(loadMoreRef, setMonths, getNextMonth);
  return (
  <div>
  <CalendarSelector
  calendars={calendars}
  selectedCalendars={selectedCalendars}
  setSelectedCalendars={setSelectedCalendars}
  calendarView={calendarView}
  setCalendarView={setCalendarView}
  selectedDate={selectedDate}
  setSelectedDate={setSelectedDate}
  /> 
{calendarView === "month" && (
  <div className="calendar-container" ref={calendarContainerRef}>
    <div className="infinite-calendar">
      {months.map((month) => (
        <MonthCalendar
          key={month.getTime()}
          month={month}
          selectedCalendars={selectedCalendars}
          setSelectedEvent={setSelectedEvent}
          googleCalendarApiKey="AIzaSyBnU1DeATMIeX9fEkQE-evj5CELQQffhoA"
          calendarContainerRef={calendarContainerRef}
          setCalendarView={setCalendarView}
          setSelectedDate={setSelectedDate}
        />
      ))}
      {/* Description from individual events as pop-up */}
      {selectedEvent && (
        <EventCard
          popupRef={popupRef}
          selectedEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}
        />
      )}
      {/* Loading buffer */}
      <div ref={loadMoreRef} className="calendar-load-more" />
    </div>
  </div>
)}
{calendarView === "day" && (
  <>
  <DayCalendar
    key={selectedDate.getTime()}
    selectedCalendars={selectedCalendars}
    googleCalendarApiKey="AIzaSyBnU1DeATMIeX9fEkQE-evj5CELQQffhoA"
    setSelectedEvent={setSelectedEvent}
    calendarContainerRef={calendarContainerRef}
    selectedDate={selectedDate}
    setSelectedDate={setSelectedDate}
  />
  {selectedEvent && (
        <EventCard
          popupRef={popupRef}
          selectedEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}
        />
      )}
</>
)}
 {calendarView === "week" && (
  <>
  <ListCalendar
    selectedCalendars={selectedCalendars}
    googleCalendarApiKey="AIzaSyBnU1DeATMIeX9fEkQE-evj5CELQQffhoA"
    setSelectedEvent={setSelectedEvent}
    calendarContainerRef={calendarContainerRef}
  />
    {/* Description from individual events as pop-up */}
      {selectedEvent && (
        <EventCard
          popupRef={popupRef}
          selectedEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}
        />
      )}
      </>
)} 
  </div>
  );
}

export default Calendar;